import axios from "axios";


const API_URL_APIM = process.env.REACT_APP_API_URL_APIM || "https://ca-prod-nouraembeddings.salmonglacier-25ca5e90.eastus.azurecontainerapps.io";

const API_URL = process.env.REACT_APP_API_URL || "https://api.nouraa.ai";
// const API_URL = "http://localhost:3002";

const API_URL_FAST = process.env.REACT_APP_API_URL_FAST || "https://fastapi.nouraa.ai";
// const API_URL_FAST = "http://localhost:5050";

const contactUs = async (contactData) => {
  try {
    const response = await axios.post(`${API_URL}/contact-us`, contactData, {
      headers: {
        "Content-Type": "application/json",
      },
      maxBodyLength: Infinity,
    });
    return response.data;
  } catch (error) {
    console.error("Contact Us error:", error.response || error.message);
    throw error;
  }
};
const register = async (email, password) => {
  try {
    const response = await axios.post(
      `${API_URL}/auth/register`,
      {
        email,
        password,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
        maxBodyLength: Infinity,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Registration error:", error.response || error.message);
    throw error;
  }
};

const login = async (email, password) => {
  try {
    const response = await axios.post(
      `${API_URL}/auth/login`,
      { email, password },
      {
        headers: {
          "Content-Type": "application/json",
        },
        maxBodyLength: Infinity,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Login error:", error.response || error.message);
    throw error;
  }
};

const forgotPassword = async (email) => {
  try {
    const response = await axios.post(
      `${API_URL}/auth/forgotpassword`,
      { email },
      {
        headers: {
          "Content-Type": "application/json",
        },
        maxBodyLength: Infinity,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Forgot Password error:", error.response || error.message);
    throw (
      error.response?.data || {
        message: "The email address is not registered.",
      }
    );
  }
};

const resetPassword = async (code, newPassword, newPasswordConfirm) => {
  try {
    const response = await axios.post(
      `${API_URL}/auth/resetpassword`,
      {
        code,
        newPassword,
        newPasswordConfirm,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
        maxBodyLength: Infinity,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Reset Password error:",
      error.response?.data || error.message
    );
    throw error;
  }
};

const saveGreetings = async (greetings, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/dynamic-prompt/greetings`,
      { greetings },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        maxBodyLength: Infinity,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Save Greetings error:", error.response || error.message);
    throw error;
  }
};

const updateInstructions = async (instructions, token) => {
  try {
    const response = await axios.patch(
      `${API_URL}/dynamic-prompt/instructions`,
      instructions,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        maxBodyLength: Infinity,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Update Instructions error:",
      error.response || error.message
    );
    throw error;
  }
};

const getCallAnalytics = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/overview/call-analytics`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Get Call Analytics error:", error.response || error.message);
    throw error;
  }
};

const getCallAnalyticsThisMonth = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/overview/call-analytics/this-month`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Get Call Analytics This Month error:",
      error.response || error.message
    );
    throw error;
  }
};

const getCallAnalyticsThisQuarter = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/overview/call-analytics/this-quarter`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Get Call Analytics This Quarter error:",
      error.response || error.message
    );
    throw error;
  }
};

const getCallLogs = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/overview/call-logs`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Get Call Logs error:", error.response || error.message);
    throw error;
  }
};

const getCallLogsThisMonth = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/overview/call-logs/this-month`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Get Call Logs This Month error:",
      error.response || error.message
    );
    throw error;
  }
};

const getCallLogsThisQuarter = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/overview/call-logs/this-quarter`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Get Call Logs This Quarter error:",
      error.response || error.message
    );
    throw error;
  }
};

const getDynamicPrompt = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/dynamic-prompt`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Get Dynamic Prompt error:", error.response || error.message);
    throw error;
  }
};

const fetchUsers = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/user/all`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch users:", error.response || error.message);
    throw error;
  }
};

const updateUserStatus = async (email, isActive, token) => {
  try {
    const response = await axios.put(
      `${API_URL}/user/status?email=${email}&isActive=${isActive}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Update User Status error:", error.response || error.message);
    throw error;
  }
};

const updateUserFunction = async (
  email,
  customFunction,
  scheduleFunctions,
  token
) => {
  try {
    const response = await axios.put(
      `${API_URL}/user/function?email=${email}&customFunction=${customFunction}&scheduleFunctions=${scheduleFunctions}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Update User Function error:",
      error.response || error.message
    );
    throw error;
  }
};

// Get user
const getUser = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/user`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Delete a user
const deleteUser = async (email, token) => {
  try {
    const response = await axios.delete(`${API_URL}/user/${email}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

const listAvailableNumbers = async (email, token) => {
  try {
    const response = await axios.get(
      `${API_URL}/user/list-available-numbers?email=${email}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data; // Returns { message: string, availableNumbers: string[] }
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Purchase a phone number
const purchaseNumber = async (email, phoneNumber, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/user/purchase-number?email=${email}&phoneNumber=${phoneNumber}`,
      null, // No request body needed
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data; // Returns { message: string, result: { phoneNumber: string } }
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Release a phone number
const releaseNumber = async (email, token) => {
  try {
    const response = await axios.put(
      `${API_URL}/user/release-number?email=${email}`,
      null,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
const getBusinessInfo = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/business-info`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
const patchBusinessInfo = async (token, data) => {
  try {
    const response = await axios.patch(`${API_URL}/business-info`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
const postBusinessInfo = async (token, data) => {
  try {
    const response = await axios.post(`${API_URL}/business-info`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

const postMinutes = async (token, data) => {
  try {
    const response = await axios.post(`${API_URL}/user/update-minutes`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// for custom prompts (functions)
const fetchCustomPrompts = async (token) => {
  const response = await axios.get(`${API_URL}/custom-prompt`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

// const createCustomPrompt = async (token, promptData) => {
//   const response = await axios.post(`${API_URL}/custom-prompt`, promptData, {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   });
//   return response.data;
// };

const updateCustomPrompt = async (token, promptData) => {
  const response = await axios.patch(`${API_URL}/custom-prompt`, promptData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

const deleteCustomPrompt = async (token) => {
  const response = await axios.delete(`${API_URL}/custom-prompt`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

const getOpenAiSession = async (token) => {
  try {
    const response = await axios.get(`${API_URL_FAST}/session`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

const handleFunctionCall = async (data, token) => {
  try {
    const response = await axios.post(
      `${API_URL_FAST}/handle-function-call`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

const markSetupComplete = async (token) => {
  try {
    const response = await axios.patch(
      `${API_URL}/user/completed`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
const createKnowledgeBase = async (knowledgeBaseData, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/knowledge-bases`,
      knowledgeBaseData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Ensure token is passed correctly
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Create Knowledge Base error:",
      error.response?.data || error.message
    );
    throw error;
  }
};

const getKnowledgeBases = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/knowledge-bases`, {
      headers: {
        Authorization: `Bearer ${token}`, // Ensure token is passed correctly
      },
    });
    return response.data || []; // Return an empty array if no data
  } catch (error) {
    console.error(
      "Get Knowledge Bases error:",
      error.response?.data || error.message
    );
    throw error;
  }
};

const addKnowledgeBaseItem = async (id, itemData, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/knowledge-bases/${id}/items`,
      itemData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Add Knowledge Base Item error:",
      error.response?.data || error.message
    );
    throw error;
  }
};

const getKnowledgeBaseItems = async (id, token) => {
  try {
    const response = await axios.get(`${API_URL}/knowledge-bases/${id}/items`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data || [];
  } catch (error) {
    console.error(
      "Get Knowledge Base Items error:",
      error.response?.data || error.message
    );
    throw error;
  }
};

const uploadKnowledgeBaseFile = async (id, file, token) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios.post(
      `${API_URL}/knowledge-bases/${id}/upload`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Upload Knowledge Base File error:",
      error.response?.data || error.message
    );
    throw error;
  }
};

const deleteKnowledgeBase = async (id, token) => {
  try {
    const response = await axios.delete(`${API_URL}/knowledge-bases/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Delete Knowledge Base error:",
      error.response?.data || error.message
    );
    throw error;
  }
};

const deleteKnowledgeBaseItem = async (id, itemId, token) => {
  try {
    const response = await axios.delete(
      `${API_URL}/knowledge-bases/${id}/items/${itemId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Delete Knowledge Base Item error:",
      error.response?.data || error.message
    );
    throw error;
  }
}

const queryPineconeForContext = async (data, token) => {
  try {
    const response = await axios.post(`${API_URL_FAST}/query-pinecone`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Failed to query Pinecone");
      return null;
    }
  } catch (error) {
    console.error("Error querying Pinecone:", error);
    return null;
  }
};

const validatePatientFormToken = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL_FAST}/validate-token/?token=${token}`
    );
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

const inValidatePatientFormToken = async (token) => {
  try {
    const response = await axios.post(
      `${API_URL_FAST}/invalidate-token/${token}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

const getNexhealthProviders = async (token) => {
  try {
    const response = await axios.get(`${API_URL_FAST}/providers`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

const registerNexhealthPatient = async (token, patientData) => {
  try {
    const response = await axios.post(`${API_URL_FAST}/patients`, patientData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

const syncKnowledgeBase = async (knowledgeBaseId, token) => {
  try {
    const response = await axios.get(`${API_URL_APIM}/api/embeddings/${knowledgeBaseId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Sync Knowledge Base error:", error.response || error.message);
    throw error;
  }
}


const authService = {
  contactUs,
  register,
  login,
  getUser,
  fetchUsers,
  deleteUser,
  listAvailableNumbers,
  purchaseNumber,
  releaseNumber,
  forgotPassword,
  resetPassword,
  saveGreetings,
  patchBusinessInfo,
  updateUserStatus,
  updateUserFunction,
  updateInstructions,
  postBusinessInfo,
  getCallAnalytics,
  getCallAnalyticsThisMonth,
  getCallAnalyticsThisQuarter,
  getCallLogs,
  getCallLogsThisMonth,
  getCallLogsThisQuarter,
  getDynamicPrompt,
  getBusinessInfo,
  fetchCustomPrompts,
  // createCustomPrompt,
  updateCustomPrompt,
  deleteCustomPrompt,
  getOpenAiSession,
  handleFunctionCall,
  postMinutes,
  queryPineconeForContext,
  markSetupComplete,
  createKnowledgeBase,
  getKnowledgeBases,
  addKnowledgeBaseItem,
  getKnowledgeBaseItems,
  uploadKnowledgeBaseFile,
  deleteKnowledgeBase,
  deleteKnowledgeBaseItem,
  validatePatientFormToken,
  inValidatePatientFormToken,
  getNexhealthProviders,
  registerNexhealthPatient,
  syncKnowledgeBase,
};

export default authService;
